import React from 'react';
import { motion } from 'framer-motion';
import { SeatedTourWidget } from './SeatedTourWidget';
export function Hero() {
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20" data-id="element-33" data-mp="ej4p21uf0jhk">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-34" data-mp="4lqf8l2zysy8">
        <motion.video initial={{
        scale: 1.1,
        opacity: 0
      }} animate={{
        scale: 1,
        opacity: 0.85
      }} transition={{
        duration: 1.5,
        ease: 'easeOut'
      }} src="https://cdn.magicpatterns.com/uploads/gBboVSJ6CTXUjcNWiurCNr/optimized_website_background.mp4" autoPlay loop muted playsInline className="w-full h-full object-cover object-center" data-id="element-35" data-mp="4n1jsn49o4qe" />
        <div className="absolute inset-0 bg-gradient-to-t from-brand-black via-brand-black/30 to-transparent" data-id="element-36" data-mp="3cz5u28857tyr" />
        <div className="absolute inset-0 bg-gradient-to-r from-brand-black via-transparent to-brand-black/60" data-id="element-37" data-mp="3j8iwsycd6eu6" />
      </div>

      <div className="relative z-10 w-full max-w-screen-2xl mx-auto px-6 md:px-12 flex flex-col items-center md:items-start text-center md:text-left" data-id="element-38" data-mp="3o858328mtl0c">
        <motion.img src="https://cdn.magicpatterns.com/uploads/1RtWnisnhQF46LZNf8vGfn/RuslanSilvr-6.png" alt="RuslanSilvr" initial={{
        opacity: 0,
        y: 50
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        ease: [0.16, 1, 0.3, 1]
      }} className="w-full max-w-[90vw] md:max-w-[80vw] h-auto mb-10 select-none" data-id="element-39" data-mp="39cfm343g57vm" />

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 1.2,
        duration: 0.8
      }} className="w-full max-w-lg" data-id="element-40" data-mp="2vj7u3bbgeade">
          <SeatedTourWidget data-id="element-41" data-mp="s44ghj521dfs" />
        </motion.div>
      </div>
    </section>;
}